// Generador determinista de SKU, PLU y EAN.
//
// Regla central: el SKU es función pura de (categoria + referencia + nombre).
// El mismo producto creado por /Master, /aiDocImport o /aiMasterImport produce
// SIEMPRE los mismos códigos. La referencia ya discrimina color y talla.
// EAN del documento, si viene, tiene prioridad sobre el SKU generado.

function normalizeSegment(value) {
  return String(value == null ? "" : value)
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, "");
}

function hash32(text) {
  let hash = 0;
  for (let i = 0; i < text.length; i++) {
    hash = (hash << 5) - hash + text.charCodeAt(i);
    hash = hash & hash;
  }
  return Math.abs(hash);
}

export function getCategoriaCode(categoria) {
  if (!categoria) return "99";
  const settings = (typeof window !== "undefined" && window.settings) || {};
  const cats = Array.isArray(settings.CATEGORIA) ? settings.CATEGORIA : [];
  const key = String(categoria).trim().toUpperCase();
  const match = cats.find((cat) => {
    if (!cat) return false;
    const v = cat.valor ? String(cat.valor).toUpperCase() : "";
    const c = cat.codigo ? String(cat.codigo).toUpperCase() : "";
    return v === key || c === key;
  });
  return match ? String(match.codigo) : "99";
}

// Hash determinista de 8 dígitos sobre (categoria | referencia | nombre).
// Sin filtros por longitud de palabra: "LANZA AGUA 14" y "LANZA AGUA 15"
// difieren porque "14" y "15" forman parte del hash.
export function generateReferenceNumber(categoria, referencia, nombreProducto) {
  const cat = normalizeSegment(categoria);
  const ref = normalizeSegment(referencia);
  const name = normalizeSegment(nombreProducto);
  const seed = `${cat}|${ref}|${name}` || "PRODUCTO";
  const numero = hash32(seed) % 99999999;
  return numero.toString().padStart(8, "0");
}

// SKU 13 dígitos: "1" + categoriaCode padded a 4 + hash(8).
// Categoría como segundo bloque (no proveedor) para que el SKU sea estable
// aunque cambie el distribuidor.
export function generateSKU(categoria, referencia, nombreProducto) {
  const refNumber = generateReferenceNumber(categoria, referencia, nombreProducto);
  const catCode = getCategoriaCode(categoria);
  const catPadded = String(catCode).padStart(4, "0");
  return "1" + catPadded + refNumber;
}

// PLU 6 dígitos: categoriaCode(2) + últimos 4 del hash de referencia.
export function generatePLU(categoria, referencia, nombreProducto) {
  if (!categoria) return "";
  const catCode = getCategoriaCode(categoria);
  if (!catCode) return "";
  const refNumber = generateReferenceNumber(categoria, referencia, nombreProducto);
  const catPadded = String(catCode).padStart(2, "0").slice(-2);
  return catPadded + refNumber.slice(-4);
}

// Helper de alto nivel: devuelve { sku, plu, ean }.
// EAN del documento (o tipeado por el usuario) gana sobre el SKU generado.
export function resolveCodes({ categoria, referencia, descripcion, ean } = {}) {
  const sku = generateSKU(categoria, referencia, descripcion);
  const plu = generatePLU(categoria, referencia, descripcion);
  const eanFromDoc = ean != null && String(ean).trim() !== "" ? String(ean).trim() : "";
  return {
    sku,
    plu,
    ean: eanFromDoc || sku,
  };
}

export default {
  getCategoriaCode,
  generateReferenceNumber,
  generateSKU,
  generatePLU,
  resolveCodes,
};
